window.reloadCaptcha = function reloadCaptcha(action, fieldName = 'g-recaptcha-response', fn = null) {
    grecaptcha.ready(function () {
        grecaptcha
            .execute($('meta[name="rv3:sitekey"]').attr('content'), {
                action: action,
            })
            .then(function (token) {
                $("input[name='" + fieldName + "'").val(token);

                if (fn) {
                    fn();
                }
            });
    });
};